const initState = {
  authError: null,
  passwordError: null,
  emailError: null,
  faceRegerror: null,
  emailSentReset: false,
  faceNewUser: null,
  createUserCompleted: null,
  createProfileCompleted: null,
  regEmailCompleted: null,
  emailWarningReset: null,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_ERROR_MAIL":
      return {
        ...state,
        authError: "EMAIL_OR_PASSWORD_WRONG",
      };
    case "LOGIN_ERROR_RESET":
      return {
        ...state,
        authError: null,
      };
    case "SIGNOUT_SUCCESS":
      return state;
    case "REG_SUCCESS":
      return {
        ...state,
        authError: null,
        passwordError: null,
        emailError: null,
        faceRegerror: null,
        regEmailCompleted: true,
      };
    case "REG_RESET_WARNINGS":
      return {
        ...state,
        authError: null,
        passwordError: null,
        emailError: null,
        faceRegerror: null,
        regEmailCompleted: false,
      };
    case "REG_ERROR_PASS":
      return {
        ...state,
        passwordError: "PASSWORD_FORM_TOO_SHORT",
      };
    case "REG_ERROR_EMAIL_INV":
      return {
        ...state,
        emailError: "EMAIL_FORM_NOT_VALID",
      };
    case "REG_ERROR_EMAIL_USED":
      return {
        ...state,
        authError: action.err,
        emailError: "EMAIL_FROM_IN_USE",
        passwordError: null,
        faceRegerror: null,
      };
    case "REG_FACE_SUCCESS":
      return {
        ...state,
        authError: null,
        user: action.user,
        passwordError: null,
        emailError: null,
        faceRegerror: null,
        faceNewUser: action.isNew,
      };
    case "REG_FACE_ERR":
      return {
        ...state,
        authError: null,
        user: null,
        passwordError: null,
        emailError: null,
        faceRegerror: action.errorCode,
        faceNewUser: null,
      };
    case "CREATE_USER_SUCCESS":
      return {
        ...state,
        createUserCompleted: true,
      };
    case "CREATE_USER_ERROR":
      return {
        ...state,
      };
    case "CREATE_PROFILE_SUCCESS":
      return {
        ...state,
        createProfileCompleted: true,
      };
    case "CREATE_PROFILE_ERROR":
      return {
        ...state,
      };
    case "RESET_PASS_SUCCESS":
      return {
        ...state,
        emailSentReset: true,
      };
    case "RESET_PASS_ERR":
      return {
        ...state,
        emailSentReset: false,
      };
    case "RESET_PASS_WARNING_RESET":
      return {
        ...state,
        emailWarningReset: null,
      };
    case "RESET_PASS_WARNING":
      return {
        ...state,
        emailWarningReset: action.error.code==="auth/too-many-requests"?"EMAIL_FORM_TO_MANY_REQUESTS":"EMAIL_FORM_NOT_VALID",
      };

    case "RESET_FACE_NEW_USER":
      return {
        ...state,
        faceNewUser: null,
      };
    case "RESET_FACE_NEW_USER_PROFILE":
      return {
        ...state,
        createUserCompleted: null,
        createProfileCompleted: null,
      };
    case "RESET_NEW_USER_PROFILE":
      return {
        ...state,
        createUserCompleted: null,
        createProfileCompleted: null,
      };
    case "RESET_REG_NEW_USER":
      return {
        ...state,
        regEmailCompleted: null,
      };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.tsx